// src/index.ts
function compare(a, b, order) {
  if (order) {
    return compare(order.indexOf(a), order.indexOf(b));
  } else {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  }
}
export {
  compare as default
};
